// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3907s","header":"ClearentDisclaimer_header__37Xfz","inner":"ClearentDisclaimer_inner__1jTbW"};